module.exports = __webpack_public_path__ + "img/xiaozhu-katong.ae4535bd.png";